import { Component, ViewChild } from '@angular/core';
import { pool, build } from '../../../../../common/classes/request-builder';
import { ActivatedRoute, Router } from '@angular/router';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../../view/base-form';
import { CamposApiService } from '../../../../../service/api/campos-api.service';
import { VisitasVariedadMesApiService } from '../../../../../service/api/visitas_variedad_mes-api.service';
import { MapaParcelasApiService } from '../../../../../service/api/mapa-parcelas-api.service';

import type { OnInit } from '@angular/core';
import { FullMapModel } from 'src/app/models/form-common/full-map.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { CamposFormDefinition } from './form-definition';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { HttpClient } from '@angular/common/http';
import { EventPhase, FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
import { CamposEnvironmentDefinition } from '../environment-variables';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Utils } from 'src/app/common/utils';
@Component({
    selector: 'app-campos-form',
    standalone: false,
    templateUrl: './campos-form.component.html',
    styleUrls: ['./campos-form.component.scss']
})
export class CamposFormComponent extends BaseForm<ParcelasModel> implements OnInit {

    @ViewChild(ReactiveFormBuilderComponent) cultivosFormBuilder!: ReactiveFormBuilderComponent<VisitasVariedadMesModel>;

    public form!: CamposFormDefinition;

    public env: CamposEnvironmentDefinition = new CamposEnvironmentDefinition();

    public formRequest = new ReactiveFormBuilderComponent(this.http);

    public mapaAux = {} as FullMapModel;

    public override model = {} as ParcelasModel;
    public modelCultivo = {} as VisitasVariedadMesModel;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public formApi: FormCommonApiService,
        public fincasApi: FincasApiService,
        public camposApi: CamposApiService,
        public mapaParcelasApi: MapaParcelasApiService,
        public override dashboard: DashboardService,
        public visitasVariedadMesApi: VisitasVariedadMesApiService,
        private readonly http: HttpClient
    ) {
        super(
            route,
            router,
            dashboard,
            camposApi.campos.PUT,
            camposApi.campos.POST,
            'campos',
            'Editar Campo',
            'Crear Campo'
        );
    }

    ngOnInit() {
        this.dropdownsFinalized = false;
        this.form = new CamposFormDefinition(
            this.getType(),
            this.getModel() as Record<string, string>,
            null
        );
        this.formRequest.executePhase(FormPhase.LOAD);
        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
            if (localStorage.getItem('TEMP_CAMPO_DATA')) {
                this.form.model = JSON.parse(localStorage.getItem('TEMP_CAMPO_DATA') ?? '');
                localStorage.removeItem('TEMP_CAMPO_DATA');
            }
            if (this.form.model.marco) {
                const parts = this.form.model.marco.split('x');
                this.form.model.marco_ancho = parts[0] ?? '';
                this.form.model.marco_largo = parts[1] ?? '';
                this.formRequest.updateForm(this.form.model, true);
            }
            resolve(true);
        });

        this.formRequest.addEvent(FormPhase.SEND, EventPhase.BEFORE, (resolve) => {
            if (this.model.mapa && this.model.mapa[0]) {
                this.mapaAux = this.model.mapa[0];
            }
            resolve(true);
        });

        this.initFormData();
        
        this.softInit(this.getType());
    }

    public async afterSendCultivo(_res: any): Promise<void> {
        localStorage.setItem('TEMP_CAMPO_DATA', JSON.stringify(this.model));
        window.location.reload();
    }

    public async afterSend(res: any): Promise<void> {
        const parcela = res?.[0];

        if (parcela && this.mapaAux.coordenadas) {
            // Rellena campos que vienen del backend de parcelas
            this.mapaAux.id_parcela = parcela.id;
            this.mapaAux.id_finca = parcela.id_finca;
            if (this.env.hasClients) {
                this.mapaAux.id_cliente = parcela.id_cliente ?? '';
            }
            this.mapaAux.id_cultivo = parcela.id_cultivo ?? '';
            this.mapaAux.id_sector = parcela.id_sector ?? '';

            try {
                
                // 1) Comprueba si ya existe un registro de mapa para esta parcela
                const existentes = await this.mapaParcelasApi.mapaParcelasGET.toPromise() as FullMapModel[] || [];
                const existente = existentes.find(m => m.id_parcela === this.mapaAux.id_parcela); // igualdad laxa por tipos

                // 2) PUT si existe, POST si no
                if (existente?.id) {
                    this.mapaAux.id = existente.id;
                    await this.mapaParcelasApi.mapaParcelasPUT.toPromise(this.mapaAux);
                } else {
                    await this.mapaParcelasApi.mapaParcelasPOST.toPromise(this.mapaAux);
                }
            } catch (e) {
                console.error('Error sincronizando mapa_parcelas', e);
                // (opcional) aquí puedes mostrar un toast/notificación
            }
        }

        this.goBack();
    }

    public formChanges(formModel: any, _tag: string) {
        this.form.model = formModel;
    }

    public formChangesCultivos(formModel: any, _tag: string) {
        this.form.model = formModel;
    }

    public getFromMapa(datos: string){
        const data = JSON.parse(datos);

        const ratio = StorageManager.getUser().ratio_ha;
        if (ratio != null && ratio !== 1) { 
            data.ha = data.ha * (ratio || 1);
            data.ha = Utils.decimalFormat(data.ha, 2);
        }


        this.form.model.cod_provincia = data.provincia;
        this.form.model.municipio = data.municipio;
        this.form.model.poligono = data.poligono;
        this.form.model.numero = data.parcela;
        this.form.model.recinto = data.recinto;
        this.form.model.superficie_sigpac = data.ha;
        this.form.model.id_cultivo = data.cultivo;
        this.form.model.id_variedad = data.variedad;
        this.form.model.sigpac = data.refpar;

        if (!this.form.model.mapa) {
            this.form.model.mapa = [{} as FullMapModel];
        }
        if (this.form.model.mapa[0]) {
            this.form.model.mapa[0].id_finca = this.model.id_finca ?? '';
            this.form.model.mapa[0].id_usuario = StorageManager.getUser().id;
            this.form.model.mapa[0].coordenadas = data.coord;
            this.form.model.mapa[0].color = data.color;
    
            if (this.form.parcelaNombre !== '' && this.form.parcelaNombre != null) {
                this.model.nombre = this.form.parcelaNombre;
            }
            else {
                this.model.nombre = `${this.env.parcelaName} ${data.parcela}`;
            }
    
        }
        
        this.form.mapaAbierto = false;
    }

    
    private initFormData(): Promise<boolean> {
        return pool([
            build(this.fincasApi.fincasGET, this.form.lists.fincas, ['nombre']),
            build(this.fincasApi.parcelasGET, this.form.lists.parcelas, ['nombre']),
            build(this.formApi.cultivosGET, this.form.lists.cultivos, 'cultivo', true),
            build(this.formApi.variedadesGET, this.form.lists.variedades, ['variedad'], true)
        ]).then(() => {
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
            return true;
        });
    }
}